import React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { FlameTheme } from '@lightspeed/flame/Core';
import { TextLink } from '@lightspeed/flame/Text';

import { createReactRenderer } from 'helpers/react-renderer';
// import useLocalizedLink from 'root/apps/hooks/useLocalizedLink';

export const CASH_ROUNDING_HELP_ARTICLE_LINK =
  'https://retail-support.lightspeedhq.com/hc/{{locale}}/articles/PLACEHOLDER';

const CashRoundingAlert: React.FC = () => {
  // const helpCentreLink = useLocalizedLink(CASH_ROUNDING_HELP_ARTICLE_LINK);

  return (
    <FlameTheme>
      <Alert
        type="info"
        title="Update your receipt template"
        noCloseBtn
        data-test="cash-rounding-alert"
        mt={1}
      >
        Your custom{' '}
        <TextLink
          onClick={(e) => {
            e.preventDefault();
            window.navigateToContent('listing', 'admin.listings.display_templates');
          }}
        >
          print template
        </TextLink>{' '}
        needs to be updated before enabling cash rounding.
        {/* Visit our{' '}
        <TextLink href={helpCentreLink} target="_blank">
          help centre
        </TextLink>{' '}
        for a step-by-step guide. */}
      </Alert>
    </FlameTheme>
  );
};

const RenderedComponent = createReactRenderer({
  component: CashRoundingAlert,
  selector: '[data-react-root="CashRoundingAlert"]',
});

export default CashRoundingAlert;

history.onChangeState(
  [
    {
      name: ['admin.views.options'],
      form_name: 'view',
      tab: ['settings'],
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
